module.exports = __webpack_public_path__ + "fonts/Inter-100-greek-ext6.2329210.woff2";